var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { getFaqs } from '../apis/faqapi';
var Faq = /** @class */ (function (_super) {
    __extends(Faq, _super);
    function Faq(props) {
        var _this = _super.call(this, props) || this;
        _this.populateFaqs = function () { return __awaiter(_this, void 0, void 0, function () {
            var faqs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFaqs()];
                    case 1:
                        faqs = _a.sent();
                        this.setState({ faqs: faqs });
                        this.setCategories();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setCategories = function () {
            // get categories and remove dups
            var cats = _this.state.faqs.map(function (data) { return data.categoryName; }).filter(function (item, index, self) { return self.indexOf(item) === index; });
            _this.setState({ categories: cats });
        };
        _this.state = {
            faqs: [],
            categories: []
        };
        return _this;
    }
    Faq.prototype.componentDidMount = function () {
        this.populateFaqs();
    };
    Faq.prototype.render = function () {
        return (React.createElement("section", { className: "content4", id: "4" },
            React.createElement("h3", null, "Frequently Asked Questions"),
            React.createElement(FaqsSection, { categories: this.state.categories, faqs: this.state.faqs })));
    };
    return Faq;
}(Component));
export default Faq;
var FaqsSection = function (props) {
    var AllFaqs = props.categories.map(function (category) {
        var faqsForCategory = props.faqs.filter(function (d) { return d.categoryName == category; });
        var startIndex = props.faqs.indexOf(faqsForCategory[0]);
        var categoryId = faqsForCategory[0].categoryId;
        return (React.createElement(Category, { key: categoryId, categoryName: category, faqs: faqsForCategory, startIndex: startIndex }));
    });
    return AllFaqs;
};
var Category = function (props) {
    var CategoryFaqs = props.faqs.map(function (faq, index) {
        var id = "ac-" + (props.startIndex + index);
        return React.createElement(FaqList, { key: faq.postID, faq: faq, id: id });
    });
    return (React.createElement("div", null,
        React.createElement("h4", null, props.categoryName),
        React.createElement("ul", null, CategoryFaqs)));
};
var FaqList = function (props) {
    return (React.createElement("li", null,
        props.faq.question,
        React.createElement("span", null, props.faq.answer)));
};
